export { OutsideClickWrapper } from './OutsideClickWrapper.component';
